<template>
  <section class="section" id="news">
    <div class="container">
      <div class="row">
        <div class="col-lg-7 col-12" id="news_section">
          <h1 class="section_title text-center">Latest News</h1>
          <div class="article mb-3" v-for="(item, index) in news" :key="index">
            <div class="row">
              <div class="col-lg-3">
                <div class="date pt-4">
                  <div class="hold mx-auto">
                    <div class="day">{{item.day}}</div>

                    <div class="month">{{item.month}}</div>
                  </div>
                  <div class="time">{{item.time}}</div>
                </div>
              </div>

              <div class="col-lg-9">
                <div class="article-content pt-4 pb-3 pr-4">
                  <h4>{{item.title}}</h4>
                  <p>{{item.description}}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="article mb-3">
            <div class="row">
              <div class="col-lg-3 d-none">
                <div class="date pt-4">
                  <div class="hold mx-auto">
                    <div class="day">16</div>

                    <div class="month">Jul</div>
                  </div>
                  <div class="time">4:30 PM</div>
                </div>
              </div>

              <div class="col-lg-9">
                <div class="article-content pt-4 pb-3 pr-4 h-100 d-flex flex-column pl-4">
                  <h4>Prayer of Salvation</h4>
                  <p>Give your life to Jesus</p>
                  <audio controls class="mt-auto">
                    <source src="/assets/audio/testimony.mp3" type="audio/mpeg" />Your browser does not support the audio element.
                  </audio>
                </div>
              </div>
            </div>
          </div>
          
        </div>
        <div class="col-lg-5">
          <contact_form></contact_form>
        </div>
      </div>
    </div>
    <div class="overlay"></div>
  </section>
</template>

<script>
import contact_form from "@/components/contact_form";
import axios from "axios";

export default {
  name: "news",
  components: {
    contact_form
  },
  created() {
    // axios
    //   .get("http://localhost:1337/church-news")
    //   .then(res => {
    //     this.news = res.data;
    //   })
    //   .catch(err => console.log(err));
  },
  data() {
    return {
      news: []
    };
  }
};
</script>

<style lang='scss' scoped>
@import "../assets/css/variables.scss";
@import "../assets/css/locate.scss";

.section_title {
  margin-bottom: 20px;
}
#news {
  padding: 50px 0;
    background-color: $tertiary-color;

  h4 {
    font-size: 20px;
  }
  #news_section {
    margin-bottom: 50px;
  }

  .form-message {
    text-align: left;
  }
  .article {
    border: 1px solid rgba(60, 72, 88, 0.25);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    max-height: 180px;
    overflow: hidden;

    @media only screen and (max-width: 990px) {
      max-height: fit-content;

      .article-content {
        padding-left: 1.5rem;
      }
    }
    .date {
      border-right: 1px solid rgba(60, 72, 88, 0.25);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 180px;
      text-align: center;
    }

    .day {
      font-size: 40px;
      border: 1px solid black;
      padding: 5px 8px;
      border-radius: 5px;
      margin-bottom: 5px;
    }

    .month {
      text-transform: uppercase;
      font-size: 30px;
      font-weight: 600;
      letter-spacing: 1px;
    }

    .time {
      background: $base-color;
      color: white;
      height: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .audio_btn {
    &:hover {
      outline: 0;
      box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18),
        0 4px 15px 0 rgba(0, 0, 0, 0.15);
    }

    padding-top: 0.7rem;
    border-radius: 10em;
    color: midnightblue !important;
    font-weight: bold;
    background-color: transparent !important;
    border: 2px solid midnightblue !important;
    color: inherit;
    text-transform: uppercase;
    word-wrap: break-word;
    white-space: normal;
    cursor: pointer;
    border: 0;
    border-radius: 0.125rem;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
      0 2px 10px 0 rgba(0, 0, 0, 0.12);
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    padding: 0.84rem 2.14rem;
    font-size: 0.81rem;
  }
}
</style>